<template>
    <v-btn
    @click="logout"
    color="primary"
    min-width="0"
    class="ma-0 pa-1 text-decoration-underline"
    text
    >
        ログアウト
    </v-btn>
</template>

<script>
import axios from '@/axios/axios'

export default {
    data() {
        return {
            show1: false,
            display_connect_title:'',

            user_id: '',
            password: '',

            error_message: '',
            cognito_id:'',
            cognito_uri:'',
            cognito_vendor_id:'',
            cognito_vendor_uri:'',
            cognito_callback_uri:'',
            cognito_callback_vendor_uri:'',
            cognito_logout_callback_uri:'',
            cognito_logout_uri:'',
            regular_url:'',
            vendor_url:'',
            vendorFlg:'',

            
        }
    },
    mounted() {
        
        this.createUrl()
        
        
    },
    methods: {
        async createUrl(){
            await this.cognitoIdConnect()
            await this.cognitoUriConnect()
            await this.cognitoVendorIdConnect()
            await this.cognitoVendorUriConnect()
            await this.cognitoCallbackUriConnect()
            await this.cognitoCallbackVendorUriConnect()
            //20250927 add
            await this.cognitoLogoutkUriConnect()
            await this.cognitoLoguotCallbackUriConnect()

            

            this.regular_url = this.cognito_uri + 'oauth2/authorize?client_id=' + this.cognito_id + '&response_type=code&scope=email+openid+phone&redirect_uri=' + this.cognito_callback_uri
            this.vendor_url = this.cognito_vendor_uri + 'oauth2/authorize?client_id=' + this.cognito_vendor_id + '&response_type=code&scope=email+openid+phone&redirect_uri=' + this.cognito_callback_vendor_uri

            
            if(this.$store.state.user_store.vendor_name == ''){
                this.vendorFlg = false
            }else{
                this.vendorFlg = true
            }
            
        },
        async cognitoIdConnect(){
            let system_id = {};

            system_id = {
                params: { "system_id" : 'cognito_id'
                }
            }
            await axios.get('/request/common/m_system_management/get', system_id).then((response) => {
                this.cognito_id = response.data.result.system_data
            })
        },

        async cognitoUriConnect(){
            let system_id = {};

            system_id = {
                params: { "system_id" : 'cognito_uri'
                }
            }
            await axios.get('/request/common/m_system_management/get', system_id).then((response) => {
                this.cognito_uri = response.data.result.system_data
            })
        },

        async cognitoVendorUriConnect(){
            let system_id = {};

            system_id = {
                params: { "system_id" : 'cognito_vendor_uri'
                }
            }
            await axios.get('/request/common/m_system_management/get', system_id).then((response) => {
                this.cognito_vendor_uri = response.data.result.system_data
            })
        },

        async cognitoVendorIdConnect(){
            let system_id = {};

            system_id = {
                params: { "system_id" : 'cognito_vendor_id'
                }
            }
            await axios.get('/request/common/m_system_management/get', system_id).then((response) => {
                this.cognito_vendor_id = response.data.result.system_data
            })
        },
        async cognitoCallbackUriConnect(){
            let system_id = {};

            system_id = {
                params: { "system_id" : 'cognito_callback_uri'
                }
            }
            await axios.get('/request/common/m_system_management/get', system_id).then((response) => {
                this.cognito_callback_uri = response.data.result.system_data
            })
        },
        //20250927add
        async cognitoLogoutkUriConnect(){
            let system_id = {};

            system_id = {
                params: { "system_id" : 'Logout_Uri'
                }
            }
            await axios.get('/request/common/m_system_management/get', system_id).then((response) => {
                this.cognito_logout_uri = response.data.result.system_data
            })
        },
        async cognitoLoguotCallbackUriConnect(){
            let system_id = {};

            system_id = {
                params: { "system_id" : 'Logout_Callback_Uri'
                }
            }
            await axios.get('/request/common/m_system_management/get', system_id).then((response) => {
                this.cognito_logout_callback_uri = response.data.result.system_data
            })
        },
        //20250927 add
        async cognitoCallbackVendorUriConnect(){
            let system_id = {};

            system_id = {
                params: { "system_id" : 'cognito_callback_vendor_uri'
                }
            }
            await axios.get('/request/common/m_system_management/get', system_id).then((response) => {
                this.cognito_callback_vendor_uri = response.data.result.system_data
            })
        },
        signOutRedirect()
        {

        },
        async logout () {
            
            
            
            //const clientId = "3sn5haqaj06frilci0pcmnqp8i";
            const clientId = this.cognito_id;
            //const logoutUri = "https%3A%2F%2Fkyoritu-susi.tohoku.coop";
            const logoutUri = this.cognito_logout_callback_uri;
            const cognitoDomain = this.cognito_logout_uri;
            //const cognitoDomain = "https://ap-northeast-1onnyixdsh.auth.ap-northeast-1.amazoncognito.com";
            //window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
            
           
            return this.$store.dispatch('auth_store/logout')
            .then(() => {
                
                if(this.vendorFlg == false){
                    //ベンダーではない
                    //this.$router.push('/login')
                    location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
                    //location.href =this.cognito_uri + 'oauth2/authorize?client_id=' + this.cognito_id + '&response_type=code&scope=email+openid+phone&redirect_uri=' + this.cognito_callback_uri
                    
                }else{
                    //ベンダー
                    location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
                    
                }
                
            })
            .catch(error => {
                console.log(error)
            })
            
        },
        showUser () {
            return this.$store.dispatch('user_store/getUser')
        },
    },
}
</script>